// GENERATED by scripts/generate-fact-sources.mjs. Do not edit by hand:
// rerun the script after a sourcing pass lands in docs/fact-sources/.
//
// The publisher each fact is sourced to, keyed by fact id like FACT_IMAGES.
// Shown as "Source: <publisher>" with no link; the url and quote behind each
// one are in docs/fact-sources/sources.json. scripts/check-fact-sources.mjs
// fails the build on a fact with no entry.

export const FACT_SOURCES = {
  1: "Smithsonian Magazine",
  2: "Hedgehog Street",
  3: "Guinness World Records",
  4: "Smithsonian's National Zoo",
  5: "Veterinary Practice News",
  6: "PDSA",
  7: "University of Chicago News",
  8: "The Conversation",
  9: "VCA Animal Hospitals",
  10: "Proceedings of the Royal Society B (2012)",
  11: "PNAS (2022)",
  12: "Science (2014)",
  13: "Smithsonian Magazine",
  14: "Marine Biological Laboratory",
  15: "Soft Matter (2021)",
  16: "Cornell Chronicle",
  17: "Discover Magazine",
  18: "Nature (2000)",
  19: "Nature News",
  20: "The Sloth Conservation Foundation",
  21: "San Diego Zoo Wildlife Alliance",
  22: "Frontiers in Endocrinology (2026)",
  23: "Australian Museum",
  24: "Biota Neotropica (2008)",
  25: "Life (2017)",
  26: "The Anatomical Record (2014)",
  27: "San Diego Zoo Wildlife Alliance",
  28: "PLOS Genetics (2013)",
  29: "Florida Museum of Natural History",
  30: "UNC Charlotte Urban Institute",
  31: "Smithsonian's National Zoo",
  32: "Smithsonian's National Zoo",
  33: "Te Papa",
  34: "San Diego Zoo Wildlife Alliance",
  35: "San Diego Zoo Wildlife Alliance",
  36: "Frontiers in Mammal Science (2024)",
  37: "Antioxidants (2021)",
  38: "Lamar University",
  39: "VCA Animal Hospitals",
  40: "Australian Museum",
  41: "Animals (2025)",
  42: "Connecticut's Beardsley Zoo",
  43: "PLOS Biology (2008)",
  44: "Merck Veterinary Manual",
  45: "Animals (2021)",
  46: "Texas A&M College of Veterinary Medicine",
  47: "LSU School of Veterinary Medicine",
  48: "American Kennel Club",
  49: "Journal of Veterinary Science (2020)",
  50: "Journal of the Acoustical Society of America (2001)",
  51: "Washington State University",
  52: "VetAgro Sup Animal Welfare Chair",
  53: "Merck Veterinary Manual",
  54: "PLOS ONE (2021)",
  55: "University of Bristol",
  56: "Animals (2025)",
  57: "Smithsonian's National Zoo",
  58: "Guinness World Records",
  59: "University of Texas Marine Science Institute",
  60: "Proceedings of the Royal Society B (2004)",
  61: "Nature News",
  62: "Smithsonian Magazine",
  63: "PNAS (2001)",
  64: "Lund University",
  65: "Science News",
  66: "San Diego Zoo Wildlife Alliance",
  67: "Global Ecology and Conservation (2025)",
  68: "Biology (2026)",
  69: "Florida Museum of Natural History",
  70: "BBC Wildlife",
  71: "Australian Museum",
  72: "University of Bristol",
  73: "Biological Journal of the Linnean Society (2008)",
  74: "Frontiers in Neuroanatomy (2022)",
  75: "Queen Mary University of London",
  76: "Stanford University",
  77: "National Geographic",
  78: "PLOS Biology (2008)",
  79: "PNAS (2013)",
  80: "National Park Service",
  81: "PLOS Biology (2008)",
  82: "University of Guelph",
  83: "University of Texas Marine Science Institute",
  84: "Behavioral Ecology and Sociobiology (2024)",
  85: "Applied Animal Behaviour Science (2024)",
  86: "NPR",
  87: "National Park Service",
  88: "San Diego Zoo Wildlife Alliance",
  89: "UF/IFAS Extension",
  90: "Proceedings of the Royal Society B (2007)",
  91: "Science (2024)",
  92: "National Geographic",
  93: "Burke Museum",
  94: "BMC Genomics (2022)",
  95: "Marine Drugs (2014)",
  96: "Folia Primatologica (2014)",
  97: "Brandeis University",
  98: "University of Georgia Savannah River Ecology Laboratory",
  99: "Florida Museum of Natural History",
  100: "Amateur Entomologists' Society",
  101: "San Diego Zoo Wildlife Alliance",
  102: "Natural History Museum, London",
  103: "National Park Service",
  104: "The Cat Fanciers' Association",
  105: "Monterey Bay Aquarium Research Institute",
  106: "Smithsonian's National Zoo",
  107: "NOAA Fisheries",
  108: "IUCN",
  109: "Marine Biological Laboratory",
  110: "Hawaii DLNR Division of Forestry and Wildlife",
  111: "Smithsonian's National Zoo",
  112: "San Diego Zoo Wildlife Alliance",
  113: "Harvard Gazette",
  114: "Australian Museum",
  115: "Smithsonian's National Zoo",
  116: "PNAS (2002)",
  117: "Smithsonian's National Zoo",
  118: "Natural History Museum, London",
  119: "Science Advances (2022)",
  120: "Scientific Reports (2025)",
  121: "University of Illinois College of Veterinary Medicine",
  122: "Proceedings of the Royal Society B (2013)",
  123: "History Colorado",
  124: "Natural History Museum, London",
  125: "Scientific Reports (2011)",
  126: "EDGE of Existence",
  127: "PNAS (2008)",
  128: "BBC Wildlife",
  129: "National Geographic",
  130: "Current Biology (2022)",
  131: "NPR",
  132: "Buffalo Bill Center of the West",
  133: "University of Illinois Chicago",
  134: "University of Washington",
  135: "Biology (2022)",
  136: "Australian Museum",
  137: "Current Biology (2012)",
  138: "Smithsonian Magazine",
  139: "British Journal of Ophthalmology",
  140: "University of Florida News",
  141: "National Geographic",
  142: "Vanderbilt University",
  143: "National Park Service",
  144: "Australian Antarctic Program",
  145: "PLOS Genetics (2005)",
  146: "Basenji Club of America",
  147: "PBS NOVA",
  148: "iScience",
  149: "Journal of Experimental Biology (2015)",
  150: "Merck Veterinary Manual",
  151: "Biology Letters (2017)",
  152: "The Conversation",
  153: "Owl Research Institute",
  154: "Animal Cognition (2017)",
  155: "PLOS ONE (2019)",
  156: "San Diego Zoo Wildlife Alliance",
  157: "PBS NOVA",
  158: "Smithsonian's National Zoo",
  159: "South African National Biodiversity Institute",
  160: "Mammalian Genome (2010)",
  161: "UC Berkeley",
  162: "Monterey Bay Aquarium",
  163: "National Park Service",
  164: "Smithsonian's National Zoo",
  165: "Smithsonian's National Zoo",
  166: "Nature Communications (2016)",
  167: "Animal Diversity Web",
  168: "San Diego Zoo Wildlife Alliance",
  169: "Canadian Journal of Zoology (1999)",
  170: "Australian Museum",
  171: "Journal of Experimental Biology (2012)",
  172: "Smithsonian's National Zoo",
  173: "San Diego Zoo Wildlife Alliance",
  174: "PNAS (2013)",
  175: "Indiana Public Media",
  176: "Proceedings of the Royal Society B (2013)",
  177: "Philosophical Transactions of the Royal Society B (2017)",
  178: "Journal of the Acoustical Society of America (2003)",
  179: "Animal Diversity Web",
  180: "Animal Diversity Web",
  181: "Australian Museum",
  182: "Royal Society Open Science (2017)",
  183: "Science (2022)",
  184: "Smithsonian's National Zoo",
  185: "Current Biology (2016)",
  186: "Proceedings of the Royal Society B (2012)",
  187: "Smithsonian's National Zoo",
  188: "Duke Lemur Center",
  189: "Revista Pesquisa FAPESP",
  190: "U.S. Customs and Border Protection",
  191: "Biology Letters (2011)",
  192: "Journal of Ethology (2016)",
  193: "Denver Zoo",
  194: "Journal of Venomous Animals and Toxins including Tropical Diseases (2013)",
  195: "Animal Diversity Web",
  196: "EarthDate",
  197: "Smithsonian's National Zoo",
  198: "Smithsonian's National Zoo",
  199: "IUCN",
  200: "Zootaxa (2026)",
  201: "Genome Biology and Evolution (2021)",
  202: "Natural History Museum, London",
  203: "Natural History Museum, London",
  204: "Biological Invasions (2008)",
  205: "PNAS (2026)",
  206: "PLOS ONE (2014)",
  207: "Proceedings of the Royal Society B (2013)",
  208: "PNAS (2013)",
  209: "PLOS ONE (2018)",
  210: "BMC Research Notes (2015)",
  211: "IUCN",
  212: "Acta Physiologica (2025)",
  213: "Royal Society Open Science (2016)",
  214: "Nature (2026)",
  215: "Science (2017)",
  216: "Science (2021)",
  217: "PLOS Biology (2008)",
  218: "Science Advances (2025)",
  219: "Proceedings of the Royal Society B (2004)",
  220: "BMC Biology (2025)",
  221: "Journal of Fish Biology (2007)",
  222: "PLOS ONE (2015)",
  223: "PLOS ONE (2015)",
  224: "American Journal of Physiology (1991)",
  225: "University of Georgia Savannah River Ecology Laboratory",
  226: "Zoological Letters (2017)",
  227: "Frontiers in Immunology (2023)",
  228: "Frontiers in Immunology (2022)",
  229: "Current Biology (2016)",
  230: "National Geographic",
  231: "National Geographic",
  232: "eLife (2023)",
  233: "Journal of Venomous Animals and Toxins including Tropical Diseases (2013)",
  234: "Journal of Venomous Animals and Toxins including Tropical Diseases (2013)",
  235: "PLOS ONE (2013)",
  236: "BBC News",
  237: "BBC News",
  238: "BBC News",
  239: "ASPCA",
  240: "National Geographic",
  241: "Smithsonian's National Zoo",
  242: "University of Minnesota",
  243: "Journal of Experimental Biology (1995)",
  244: "Journal of Anatomy (2007)",
  245: "Cornell Chronicle",
  246: "Cornell Chronicle",
  247: "Live Science",
  248: "Australian Antarctic Program",
  249: "Florida Museum of Natural History",
  250: "The Conversation",
  251: "WWF",
  252: "The Conversation",
  253: "Ohio University",
  254: "University of Cape Town",
  255: "Proceedings of the Royal Society B (2014)",
  256: "Proceedings of the Royal Society B (2014)",
  257: "Smithsonian's National Zoo",
  258: "LafeberVet",
  259: "Smithsonian's National Zoo",
  260: "Natural History Museum, London",
  261: "Journal of Experimental Biology (2015)",
  262: "Smithsonian's National Zoo",
  263: "Amphibian & Reptile Conservation (2019)",
  264: "Toronto Zoo",
  265: "ZooKeys (2024)",
  266: "Honolulu Zoo",
  267: "Honolulu Zoo",
  268: "Honolulu Zoo",
  269: "Smithsonian's National Zoo",
  270: "American Kennel Club",
  271: "Smithsonian's National Zoo",
  272: "NOAA Fisheries",
  273: "Frontiers in Ecology and Evolution (2022)",
  274: "The Wolverine Foundation",
  275: "National Park Service",
  276: "San Diego Zoo Wildlife Alliance",
  277: "ScienceDaily",
  278: "National Park Service",
  279: "NOAA Flower Garden Banks National Marine Sanctuary",
  280: "Science News",
  281: "BirdLife International",
  282: "Natural History Museum, London",
  283: "Canon Bird Branch Project",
  284: "Los Angeles Zoo and Botanical Gardens",
  285: "Los Angeles Zoo and Botanical Gardens",
  286: "Journal of the Royal Society Interface (2013)",
  287: "New Zealand Department of Conservation",
  288: "The Cat Fanciers' Association",
  289: "San Diego Zoo Wildlife Alliance",
  290: "Frontiers in Zoology (2022)",
  291: "British Journal of Dermatology (2026)",
  292: "New Zealand Department of Conservation",
  293: "American Kennel Club",
  294: "San Diego Zoo Wildlife Alliance",
  295: "Monterey Bay Aquarium Research Institute",
  296: "National Geographic",
  297: "Journal of Experimental Biology (2010)",
  298: "Boletim do Instituto de Pesca (2018)",
  299: "USGS Nonindigenous Aquatic Species",
  300: "Nature (2024)",
  301: "Pigment Cell & Melanoma Research (2010)",
  302: "PLOS ONE (2011)",
  303: "National University of Singapore",
  304: "Ichthyological Exploration of Freshwaters (1999)",
  305: "UF/IFAS Extension",
  306: "Crustacean Research (2020)",
  307: "World Register of Marine Species",
  308: "Cold Spring Harbor Protocols (2014)",
  309: "Merck Veterinary Manual",
  310: "Clark University",
  311: "Experimental Animals (1986)",
  312: "San Francisco Zoo & Gardens",
  313: "Journal of North American Herpetology (2014)",
  314: "Los Angeles Zoo and Botanical Gardens",
  315: "Animal Behaviour (2000)",
  316: "Science (2009)",
  317: "San Diego Zoo Wildlife Alliance",
  318: "Audubon",
  319: "BBC Wildlife",
  320: "Australian Museum",
  321: "Animal Genetics (2019)",
  322: "Animal Diversity Web",
  323: "Natural History Museum, London",
  324: "Live Science",
  325: "National Park Service",
  326: "Audubon",
  327: "Journal of Experimental Biology (2000)",
  328: "The Living Coast Discovery Center",
  329: "Science Advances (2019)",
  330: "American Kennel Club",
  331: "Western Australian Department of Biodiversity, Conservation and Attractions",
  332: "PLOS ONE (2011)",
  333: "Natural History Museum, London",
  334: "Proceedings of the Royal Society B (2005)",
  335: "Animal Diversity Web",
  336: "The University of the West Indies",
  337: "American Kennel Club",
  338: "Journal of Fish Biology (2020)",
  339: "Los Angeles Zoo and Botanical Gardens",
  340: "San Diego Zoo Wildlife Alliance",
  341: "Los Angeles Zoo and Botanical Gardens",
  342: "Monterey Bay Aquarium",
  343: "National Geographic",
  344: "Universities Federation for Animal Welfare",
  345: "Smithsonian's National Zoo",
  346: "Ecology (2022)",
  347: "Nature Communications (2015)",
  348: "San Diego Zoo Wildlife Alliance",
  349: "Xoloitzcuintli Club of America",
  350: "Duke University",
  351: "Australian Geographic",
  352: "PNAS (2022)",
  353: "PDSA",
  354: "Indiana Public Media",
  355: "Houston Zoo",
  356: "New Zealand Department of Conservation",
  357: "VCA Animal Hospitals",
};

// The publisher a fact is sourced to, or null when none has been recorded.
export function sourceFor(fact) {
  const id = fact && (fact.id || fact._id);
  return (id && FACT_SOURCES[id]) || null;
}
